import MaUIErrorHandlingScreen from "./MaUIErrorHandlingScreen";
import MaUILoadingScreen from "./MaUILoadingScreen";
import Pages from "./Pages";

export default Pages;

export { MaUILoadingScreen, MaUIErrorHandlingScreen };
